import { Skeleton } from '@avanta/shared/components/ui/Skeleton';
import { StepSection } from '../../../ui/StepSection';

const SELECTS_PER_SECTION = 2;

const SelectFieldSkeleton = (): React.ReactElement => (
  <div className="flex flex-col gap-2">
    <Skeleton className="h-3.5 w-24" />
    <Skeleton className="h-10 w-full rounded-lg" />
  </div>
);

const SelectsSectionSkeleton = (): React.ReactElement => (
  <StepSection
    title={<Skeleton className="h-5 w-40" />}
    className="flex w-full gap-6 *:flex-1"
    containerClassName="w-full"
  >
    {Array.from({ length: SELECTS_PER_SECTION }).map((_, index) => (
      <SelectFieldSkeleton key={`select-${index}`} />
    ))}
  </StepSection>
);

export const SessionStepSkeleton = (): React.ReactElement => (
  <div className="flex flex-col gap-10 w-3xl">
    <SelectsSectionSkeleton />
    <SelectsSectionSkeleton />
    <div className="flex w-full justify-end">
      <Skeleton className="h-10 min-w-37 w-37 rounded-[20px]" />
    </div>
  </div>
);
